export enum ActivityLogEventType {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted',
  // Dedicated event written by the core when a subscription moves to another
  // plan (admin action or age-limit fallback at renewal).
  PLAN_CHANGED = 'plan-changed',
}

interface Causer {
  first_name: string
  last_name: string
}

interface Properties {
  attributes: any
  old?: any
}

export interface ActivityLog {
  id: number
  event: ActivityLogEventType
  logName: string
  subjectId: number
  causer?: Causer
  properties: Properties
  createdAt: string
  updatedAt: string
}

export const eventColors: Record<ActivityLogEventType, string> = {
  [ActivityLogEventType.CREATED]: 'green',
  [ActivityLogEventType.UPDATED]: 'orange',
  [ActivityLogEventType.DELETED]: 'red',
  [ActivityLogEventType.PLAN_CHANGED]: 'blue',
}

/** Wording for events whose raw name does not read well in a sentence. */
export const eventLabels: Partial<Record<string, string>> = {
  [ActivityLogEventType.PLAN_CHANGED]: 'plan changed',
}

export const entityLabels: Record<string, string> = {
  'membership-demo-booklet': 'Demo booklet',
  'membership-demo-tab-photo': 'Demo tab photo',
  'membership-demo-tab-texts': 'Demo tab texts',
  'membership-subscription': 'Subscription',
  'venue collection': 'Venue Collection',
  'venue collection translation': 'Venue Collection',
  'venue gallery item': 'Gallery item',
  'venue translation': 'Venue',
  venue: 'Venue',
  address: 'Address',
  'menu translation': 'Menu',
  menu: 'Menu',
  notification: 'Notification',
  'notification translation': 'Notification',
}
